import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "./screens/LandingPage";
import MenuPage from "./screens/MenuPage";
import CheckoutPage from "./screens/CheckoutPage";
import SelectTablePage from "./screens/SelectTablePage";
import OrderPage from "./screens/OrderPage";
import FinalPage from "./screens/FinalPage";
import LoginScreen from "./screens/LoginScreen";
import Layout from "./components/Layout/Layout";
import MenuList from "./screens/MenuList";
import AddMenu from "./screens/AddMenu";
import AddCategory from "./screens/AddCategory";
import RobotsList from "./screens/RobotsList";
import OrderList from "./screens/OrderList";
import OrderDetails from "./screens/OrderDetails";
import TableList from "./screens/TableList";
import AddTable from "./screens/AddTable";
import CategoryList from "./screens/CategoryList";
import PrivateRoutes from "./constants/PrivateRoutes";

const ReactRoutes = () => {
  const token = localStorage.getItem("token");
  const [menuOpen, setMenuOpen] = useState(false);
  const toggle = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <Routes>
      <Route path="/" index element={<LoginScreen />} />
      <Route element={<PrivateRoutes token={token} />}>
        <Route path="/welcome" index element={<LandingPage />} />
        <Route path="/menu" index element={<MenuPage />} />
        <Route path="/checkout" index element={<CheckoutPage />} />
        <Route path="/order" index element={<OrderPage />} />
        <Route path="/final-page" index element={<FinalPage />} />
        <Route path="/select-table" index element={<SelectTablePage />} />
        {/* ADMIN PANEL */}
        <Route element={<Layout menuOpen={menuOpen} toggle={toggle} />}>
          <Route
            path="/admin-menu"
            element={<MenuList menuOpen={menuOpen} />}
          />
          <Route path="/add-menu" element={<AddMenu menuOpen={menuOpen} />} />
          <Route
            path="/add-category"
            element={<AddCategory menuOpen={menuOpen} />}
          />
          <Route
            path="/robots-list"
            element={<RobotsList menuOpen={menuOpen} />}
          />
          <Route
            path="/category-list"
            element={<CategoryList menuOpen={menuOpen} />}
          />
          <Route
            path="/order-list"
            element={<OrderList menuOpen={menuOpen} />}
          />
          <Route
            path="/order-details"
            element={<OrderDetails menuOpen={menuOpen} />}
          />
          <Route
            path="/table-list"
            element={<TableList menuOpen={menuOpen} />}
          />
          <Route path="/add-table" element={<AddTable menuOpen={menuOpen} />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default ReactRoutes;
